<template>
    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="settings.icon" class="mr-1"></i>
                        <span>{{ settings.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Name" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="name" :debounce="settings.debounce"
                                            placeholder="Name"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!name"
                                                @click="name = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Category" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="category" :debounce="settings.debounce"
                                            placeholder="Category"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!category"
                                                @click="category = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="settings" :icon="settings.icon"
                        :busy="settings.busy" :toolbarlibrary="settings.toolbarlibrary" :tools="settings.tools"
                        :badges="settings.badges" :fields="settings.fields" :items="settings.items"
                        :limit="settings.limit" :showpages="true" :offset="settings.offset" :page="settings.page"
                        :downloaded="settings.downloaded" @load="settings_load" @click="settings_click"
                        @changed="settings_click('save', $event)" @select="settings_select">
                    </d-table>
                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="settings.selected" :config="cconfig"
                    @discard="settings_click('discard')" @go="settings_click('go')"></component>
            </div>
            <!-- <b-card-footer class="mt-2 ml-1">
                <b-row>
                    <b-col class="nopadding text-center">
                        <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                            <i class="fa fa-bars mr-2"></i>All Codes
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-footer> -->
        </b-card>
    </div>
</template>


<script>
import gql from "graphql-tag";

import SystemSettingEdit from "./Components/Setup_SystemSettingEdit";

export default {
    name: "Setup_SystemSettings",
    components: { SystemSettingEdit },
    watch: {
        async name() {
            await this.settings_load(0);
        },
        async category() {
            await this.settings_load(0);
        },
    },
    data() {
        return {
            name: null,
            category: null,

            settings: {
                title: "System Setup",
                icon: "fa fa-cog",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                tools: "go,filter,download,clipboard,add,edit,deleteconfirm,reset",
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-power text-danger",
                        position: "toolbar",
                        action: "reset",
                        label: "Reset",
                        disabled: true,
                        component: {
                            name: "",
                        },
                    },

                ],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },

                    {
                        key: "name",
                        label: "Name",
                        sortable: true,
                    },
                    {
                        key: "category",
                        label: "Category",
                        sortable: true,
                    },
                    {
                        key: "data",
                        label: "Data",
                        sortable: true,
                        type: "text",
                        class: "text-left",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 200) {
                                    result = result.slice(0, 197) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center w-100px",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-right w-100px",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [
                    {
                        key: "category",
                        type: "badge",
                        Accounts: "info",
                        Anvil: "success",
                        DB: "success",
                        PNR: "purple",
                        SMTP: "warning",
                        Portal: "success",
                        Email: "warning",
                        ticketing: "orange",
                        ["User Experience"]: "purple",
                        Security_policy: "primary",
                        Password_policy: "secondary",
                        Documents: "dark",
                        Reports: "dark",
                        API: "danger",
                        UX: "dark",
                        Charts: "light",
                        Firewall: "danger",
                        formatter: (value, key, item) => {
                            switch (value) {
                                case "db":
                                    return "DB";
                                    break;
                                case "smtp":
                                    return "SMTP";
                                    break;
                                case "portal":
                                    return "Portal";
                                    break;
                                case "email":
                                    return "Email";
                                    break;
                                case "security_policy":
                                    return "Security_policy";
                                    break;
                                case "password_policy":
                                    return "Password_policy";
                                    break;
                                case "anvil":
                                    return "Anvil";
                                    break;
                                case "api":
                                    return "API";
                                    break;
                                case "ux":
                                    return "UX";
                                    break;
                                case "charts":
                                    return "Charts";
                                    break;
                                case "documents":
                                    return "Documents";
                                    break;
                                case "reports":
                                    return "Reports";
                                    break;
                                case "accounts":
                                    return "Accounts";
                                    break;
                                case "firewall":
                                    return "Firewall";
                                    break;
                                default:
                                    return value;
                            }
                        },
                    },
                ],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    async mounted() {
        this.accessdenied();
        await this.settings_load();
    },

    methods: {
        accessdenied() {
            this.settings.denied = [];
            if (!this.user.permissions.includes("setup_systemsettings.admin")) {
                this.settings.denied.push("deleteconfirm");
                this.settings.denied.push("reset");
            }
            if (!this.user.permissions.includes("setup_systemsettings.admin")) {
                this.settings.denied.push("add");
                this.settings.denied.push("save");
            }

        },

        async settings_load(offset, limit, page) {
            let state = this.settings;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                category: this.category,
                name: this.name,
                dateformat: "DD/MM/YYYY",
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
               query setup_systemsettings(
                $limit: Int
                $offset: Int
                $name: String              
                $category: String
                $dateformat: String
              ) {
                setup_systemsettings(
                  limit: $limit
                  offset: $offset
                  category: $category
                  name: $name                 
                  dateformat: $dateformat
                ) {
                  id
                  name                 
                  category
                  data                
                  rows
                  updated_at
                  updated_by
                }
              }
            `,
                    variables,
                });

                // USE LOCAL VARIABLE

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.setup_systemsettings
                } else {
                    state.items = response.data.setup_systemsettings;
                }

            } catch (error) {
                console.log(error);
            }

            state.busy = false;
        },
        async settings_click(a, ss) {
            let state = this.settings;

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = this.state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.settings_load(0, 0);
                    break;

                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    await this.settings_load();
                    break;
                case "go":
                    this.component = null;
                    await this.settings_load();
                    break;
                case "add":
                case "edit":
                    this.component = "SystemSettingEdit";
                    break;

                case "save":
                    this.saveit(ss);
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;

                case "reset":
                    await this.reset(ss);
                    break;
            }
        },
        async settings_select(ss, tools) {

            let state = this.settings;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download", "reset", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
        async settings_changed(ss) {
            console.log("settings_changed", ss);
            await this.saveit(ss);
        },

        async saveit(ss) {
            this.busy = true;

            let variables = { rows: this.cleanit(ss) };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation setup_systemsettings_save(
                            $rows: [setup_systemsettings_input]
                        ) {
                            setup_systemsettings_save(rows: $rows) {
                            id
                            category
                            name                  
                                data
                            }
                        }
                        `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
        async deleteit(ss) {

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
               mutation setup_systemsettings_delete(
                $rows: [setup_systemsettings_input]
              ) {
                setup_systemsettings_delete(rows: $rows) {
                  id
  
                }
              }
            `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.settings_load(0);
        },

        async reset(ss) {

            if (await this.$bvModal.msgBoxConfirm('Systems settings table will be reset to original values.', {
                title: 'Please confirm you want to reset the settings?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {
                console.log("reset", ss);
                let state = this.settings

                state.busy = true

                try {
                    const response = await this.$apollo.mutate({
                        mutation: gql`
                        mutation setup_systemsettings_reset {
                        setup_systemsettings_reset
                }
          `,
                    });
                }
                catch (error) {
                    this.message = "<span class='text-danger'>" + error.message + "</span>";
                }
                state.busy = false
                await this.settings_load(0);

            } else {
                state.busy = false
            }
            await this.settings_load(0);

        },

    },
};
</script>

<style></style>